// redux/slices/savedPdfsSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  savedPdfs: [], // Holds the IDs of saved PDFs
  saveCounts: {}, // Holds the save count for each PDF
  status: 'idle', // Track the status of API calls (loading, success, failed)
  error: null, // Error message
};

// Async thunk to fetch saved PDFs
export const fetchSavedPdfs = createAsyncThunk(
  'savedPdfs/fetchSavedPdfs',
  async (userId) => {
    const response = await fetch(`${process.env.REACT_APP_SAVE_PDF}?user_id=${userId}`);
    const data = await response.json();
    return data.map((pdf) => pdf.id); // Return the list of saved PDF IDs
  }
);

// Async thunk to fetch save count for a specific PDF
export const fetchSaveCount = createAsyncThunk(
  'savedPdfs/fetchSaveCount',
  async (pdfId) => {
    const response = await fetch(`${process.env.REACT_APP_SAVE_PDF}?pdf_id=${pdfId}`);
    const data = await response.json();
    return { pdfId, count: data.save_count }; // Return the PDF ID and its save count
  }
);

const savedPdfsSlice = createSlice({
  name: 'savedPdfs',
  initialState,
  reducers: {
    resetSavedPdfs: (state) => {
      state.savedPdfs = [];
      state.saveCounts = {};
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetching saved PDFs
      .addCase(fetchSavedPdfs.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchSavedPdfs.fulfilled, (state, action) => {
        state.savedPdfs = action.payload;
        state.status = 'succeeded';
      })
      .addCase(fetchSavedPdfs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      // Handle fetching save count
      .addCase(fetchSaveCount.fulfilled, (state, action) => {
        const { pdfId, count } = action.payload;
        state.saveCounts[pdfId] = count; // Update the save count for the specific PDF
      });
  },
});

export const { resetSavedPdfs } = savedPdfsSlice.actions;

export default savedPdfsSlice.reducer;
